module.exports = __webpack_public_path__ + "img/keterlambatan.04379554.png";